import React from 'react';

export type DisclaimerProps = {
  className?: string;
  contents?: React.ReactNode;
};

const defaultContents = (
  <>
    Bonjoro sent you this email on behalf of a Bonjoro creator. We aren’t
    responsible for its content. If you suspect abuse, like suspicious links,
    please report it <span className='underline text-turquoise-700'>here</span>.
  </>
);

const Disclaimer = ({
  className = '',
  contents = defaultContents,
}: DisclaimerProps) => (
  <p
    className={`text-xs text-left text-neutral-700 px-10 whitespace-normal ${className}`}
  >
    {contents}
  </p>
);

export default Disclaimer;
